import Model, { hasMany } from '@ember-data/model';
import TaskActionModel from './task-action';
import TaskMediumModel from './task-medium';
import TaskResultModel from './task-result';

export default class TaskAssociationModel extends Model {
  @hasMany('task-action', { async: false, inverse: null })
  declare taskActions: TaskActionModel[];
  @hasMany('task-medium', { async: false, inverse: null })
  declare taskMediums: TaskMediumModel[];
  @hasMany('task-result', { async: false, inverse: null })
  declare taskResults: TaskResultModel[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'task-association': TaskAssociationModel;
  }
}
